import { createFeatureSelector } from "@ngrx/store";
import { BannerStoreState } from "./state";

export const selectBannerState = createFeatureSelector<BannerStoreState>('announcement');

